module.exports = __webpack_public_path__ + "img/lugares4.f6aa1823.jpg";